<div id="incepted-ape-container">
    <!-- Sprinner -->
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }
    <div id="incepted-ape-card-container" class="container-fluid">
        <!-- <div id="incepted-ape-header">
            <h5 class="page-header">Incepted APE</h5>
        </div> -->

        <div id="incepted-ape-card-body" class="row">
            <div id="incepted-ape-month-to-date" class="col-6 ape-card-container">
                <app-incepted-ape-card-v2
                    title="Incepted APE"
                    period="Month to Date"
                    [segments]="inceptedApeMtdSegments"
                    [expanded]="expandedIncepted === 'mtd'"
                    (toggleView)="toggleIncepted('mtd')">
                </app-incepted-ape-card-v2>
            </div>


            <div id="incepted-ape-year-to-date" class="col-6 ape-card-container">
                <app-incepted-ape-card-v2
                    title="Incepted APE"
                    period="Year to Date"
                    [segments]="inceptedApeYtdSegments"
                    [expanded]="expandedIncepted === 'ytd'"
                    (toggleView)="toggleIncepted('ytd')">
                    @if (this.currentUserRole === 'Corporate') {
                    <div apeCardExtra class="ape-target-block">
                        <div class="ape-target-col">
                            <span class="ape-target-label">{{ this.targetYear }} Target</span>
                            <span class="ape-target-value">{{ this.inceptedApeSummary.yearTarget | currency: 'SGD' :
                                'symbol-narrow' : '1.0-0' }}</span>
                        </div>
                        <div class="ape-target-col">
                            <span class="ape-target-label">Shortfall / Overachieve</span>
                            @if (this.totalYearInceptedApe >= this.inceptedApeSummary.yearTarget) {
                            <span class="ape-target-value pos">{{ (this.totalYearInceptedApe -
                                this.inceptedApeSummary.yearTarget) | currency: 'SGD' : 'symbol-narrow' : '1.0-0'
                                }}</span>
                            } @else {
                            <span class="ape-target-value neg">{{ (this.inceptedApeSummary.yearTarget -
                                this.totalYearInceptedApe) | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
                            }
                        </div>
                    </div>
                    }
                </app-incepted-ape-card-v2>
            </div>
        </div>

        @if (expandedIncepted === 'mtd') {
        <div class="row incepted-drawer-row">
            <div class="col-12">
                <app-incepted-ape-drawer-v2 period="Month to Date" 
                    [segments]="inceptedApeMtdSegments"></app-incepted-ape-drawer-v2>
            </div>
        </div>
        }
        @if (expandedIncepted === 'ytd') {
        <div class="row incepted-drawer-row">
            <div class="col-12">
                <app-incepted-ape-drawer-v2 period="Year to Date"
                    [segments]="inceptedApeYtdSegments"></app-incepted-ape-drawer-v2>
            </div>
        </div>
        }

        <div id="incepted-ape-card-body" class="row">
            <div id="incepted-ape-month-to-date" class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 ape-card-container">
                <app-ape-stat-card-v2
                    title="Submission APE"
                    period="Month to Date"
                    valueLabel="Singlife"
                    accent="#1daf46"
                    [value]="inceptedApeSummary.monthSubmissionSinglife"
                    [cases]="inceptedApeSummary.monthSubmissionSinglifeCase"></app-ape-stat-card-v2>
            </div>


            <div id="incepted-ape-month-to-date" class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 ape-card-container">
                <app-ape-stat-card-v2
                    title="Submission APE"
                    period="Year to Date"
                    valueLabel="Singlife"
                    accent="#1daf46"
                    [value]="inceptedApeSummary.yearSubmissionSinglife"
                    [cases]="inceptedApeSummary.yearSubmissionSinglifeCase"></app-ape-stat-card-v2>
            </div>
            <div id="incepted-ape-month-to-date" class="col-sm-12 col-md-6 col-lg-4 col-xxl-4 ape-card-container">
                <app-ape-stat-card-v2
                    title="Pending APE"
                    period="Year to Date"
                    valueLabel="Singlife"
                    accent="#EFD80A"
                    [value]="inceptedApeSummary.yearPendingSinglife"
                    [cases]="inceptedApeSummary.yearPendingSinglifeCase"></app-ape-stat-card-v2>
            </div>
        </div>
        <p class="comment-content"><b>Disclaimer:</b> {{this.inceptedApeMtdDisclaimer}}</p>
    </div>

    <!-- APE list By Managers and Director -->

    <!-- Incepted APE By Managers -->
    <div id="incepted-ape-by-manager-table-container" class="container-fluid"
        [hidden]="this.isInceptedApeByManagerTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-manager-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-manager-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By Team)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByManagerTableFilterFc"
                        (keyup)="__applyInceptedApeByManagerDataFilter()" placeholder="Search managers..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByManagerTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearInceptedManagerSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <mat-divider class="pias-divider"></mat-divider>

                <!-- Incepted APE Manager Data List table -->
                <div id="incepted-ape-by-manager-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByManagerTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByManagerTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Rep Code Column — carries the chevron that expands the carrier chips -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 130px;">
                                <button type="button" class="ape-expand-btn"
                                    [class.open]="isInceptedManagerRowExpanded(apeData.repCode)"
                                    [attr.aria-expanded]="isInceptedManagerRowExpanded(apeData.repCode)"
                                    [attr.aria-label]="'Show carrier breakdown for ' + apeData.repCode"
                                    (click)="toggleInceptedManagerRow(apeData.repCode)">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                                {{apeData.repCode}}
                            </td>
                        </ng-container>

                        <!-- Person Name Column -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                <a class="branch-popup-link"
                                    (click)="__displayInceptedManagerWiseAdvisors(apeData.repCode, apeData.personName)">
                                    {{apeData.personName}} </a>
                            </td>
                        </ng-container>

                        <!-- Branch Name Column -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- MTD — total across every carrier, expanding into per-carrier chips -->
                        <ng-container matColumnDef="mtdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="monthTotal"
                                class="align-middle fw-bold"> Month to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.monthTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.monthTotalCase }} cases</span>
                                </div>
                                @if (isInceptedManagerRowExpanded(apeData.repCode)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix"> 
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){     
                                        <span class="ape-mix-seg" [style.width]="carrier.mtdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){     
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.mtdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.mtdCase }}
                                                {{ carrier.mtdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- YTD — same cell, year to date -->
                        <ng-container matColumnDef="ytdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="yearTotal"
                                class="align-middle fw-bold"> Year to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell ytd">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.yearTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.yearTotalCase }} cases</span>
                                </div>
                                @if (isInceptedManagerRowExpanded(apeData.repCode)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.ytdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.ytdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.ytdCase }}
                                                {{ carrier.ytdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- Year Total Column — hidden for now; the YTD cell already carries the
                             same figure. Also commented out of the display column list in the .ts.
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold"> Year Total
                            </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end ape-year-total"> {{ apeData.yearTotal
                                |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>
                        -->

                        <!-- Header Row -->
                        <tr mat-header-row *matHeaderRowDef="inceptedApeByManagerTableDisplayDataRow; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByManagerTableDisplayDataRow;"
                            [class.ape-row-open]="isInceptedManagerRowExpanded(row.repCode)"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByManagerTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- Submission APE By Managers -->
    <div id="submission-ape-by-manager-table-container" class="container-fluid"
        [hidden]="this.isSubmissionApeByManagerTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="submission-ape-by-manager-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="submission-ape-by-manager-table-exapansion-header">
                        <h5 class="page-header">Submission & Pending APE (By Team)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="submissionApeByManagerTableFilterFc"
                        (keyup)="__applySubmissionApeByManagerDataFilter()" placeholder="Search managers..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="submissionApeByManagerTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearSubmissionManagerSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <mat-divider class="pias-divider"></mat-divider>

                <!-- Submission APE Manager Data List table -->
                <div id="submission-ape-by-manager-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="submissionApeByManagerTableDataSource" matSort matSortDisableClear
                        matSortActive="yearPendingSinglifeCase" matSortDirection="desc"
                        #submissionApeByManagerTableSort="matSort" class="custom-mat-table">

                        <!-- Rep Code Column (rowspan=2) -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 100px;">
                                {{apeData.repCode}}
                                <!-- <a class="branch-popup-link"
                                    (click)="__displayManagerWiseAdvisors(apeData.repCode, apeData.personName)">
                                    {{apeData.repCode}} </a> -->
                            </td>
                        </ng-container>

                        <!-- Person Name Column (rowspan=2) -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                <a class="branch-popup-link"
                                    (click)="__displaySubmissionManagerWiseAdvisors(apeData.repCode, apeData.personName)">
                                    {{apeData.personName}} </a>
                            </td>
                        </ng-container>

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year pendinglife group -->
                        <ng-container matColumnDef="header-row2-year-pendinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Pending Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.monthSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Non-Singlife APE Column -->
                        <ng-container matColumnDef="yearPendingSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearPendingSinglife |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Non-Singlife Case Column -->
                        <ng-container matColumnDef="yearPendingSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearPendingSinglifeCase}}
                            </td>
                        </ng-container>
                        <!-- First Header Row (with Rep Code, Name, Group Headers, and Year Total) -->
                        <tr mat-header-row
                            *matHeaderRowDef="submissionApeByManagerTableDisplayFirstColumn; sticky: true">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="submissionApeByManagerTableDisplaySecondColumn; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: submissionApeByManagerTableDisplayDataRow;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Submission APE Data Table Paginator -->
                    <mat-paginator #submissionApeByManagerTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of submission APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- APE list By Advisors  -->

    <!-- Incepted APE By Advisors-->
    <div id="incepted-ape-by-advisor-table-container" class="container-fluid"
        [hidden]="isInceptedApeByAdvisorTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-advisor-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-advisor-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By advisor)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Incepted APE (By advisor) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By advisor)</mat-label>
                        <input matInput [formControl]="inceptedApeByAdvisorTableFilterFc"
                            (keyup)="__applyInceptedApeByAdvisorDataFilter()" placeholder="Ex. Rep. Code, name" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByAdvisorTableFilterFc"
                        (keyup)="__applyInceptedApeByAdvisorDataFilter()" placeholder="Search advisors..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByAdvisorTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearInceptedApeByAdvisorSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Incepted APE Data List table -->
                <div id="incepted-ape-by-advisor-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByAdvisorTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByAdvisorTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Rep Code Column (rowspan=2) -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 130px;">
                                <button type="button" class="ape-expand-btn"
                                    [class.open]="isInceptedAdvisorRowExpanded(apeData.repCode)"
                                    [attr.aria-expanded]="isInceptedAdvisorRowExpanded(apeData.repCode)"
                                    [attr.aria-label]="'Show carrier breakdown for ' + apeData.repCode"
                                    (click)="toggleInceptedAdvisorRow(apeData.repCode)">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                                {{apeData.repCode}}
                            </td>
                        </ng-container>

                        <!-- Person Name Column -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                {{apeData.personName}} </td>
                        </ng-container>

                        <!-- Branch Name Column -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- MTD — total across every carrier, expanding into per-carrier chips -->
                        <ng-container matColumnDef="mtdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="monthTotal"
                                class="align-middle fw-bold"> Month to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.monthTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.monthTotalCase }} cases</span>
                                </div>
                                @if (isInceptedAdvisorRowExpanded(apeData.repCode)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.mtdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.mtdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.mtdCase }}
                                                {{ carrier.mtdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- YTD — same cell, year to date -->
                        <ng-container matColumnDef="ytdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="yearTotal"
                                class="align-middle fw-bold"> Year to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell ytd">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.yearTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.yearTotalCase }} cases</span>
                                </div>
                                @if (isInceptedAdvisorRowExpanded(apeData.repCode)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.ytdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.ytdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.ytdCase }}
                                                {{ carrier.ytdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- Year Total Column — hidden for now; the YTD cell already carries the
                             same figure. Also commented out of the display column list in the .ts.
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold"> Year Total
                            </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end ape-year-total"> {{ apeData.yearTotal
                                |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>
                        -->

                        <!-- Header Row -->
                        <tr mat-header-row *matHeaderRowDef="inceptedApeByAdvisorTableDisplayDataRow; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByAdvisorTableDisplayDataRow;"
                            [class.ape-row-open]="isInceptedAdvisorRowExpanded(row.repCode)"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- Submission APE By Advisors-->
    <div id="submission-ape-by-advisor-table-container" class="container-fluid"
        [hidden]="isSubmissionApeByAdvisorTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="submission-ape-by-advisor-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="submission-ape-by-advisor-table-exapansion-header">
                        <h5 class="page-header">Submission & Pending APE (By advisor)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Submission APE (By advisor) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By advisor)</mat-label>
                        <input matInput [formControl]="inceptedApeByAdvisorTableFilterFc"
                            (keyup)="__applyInceptedApeByAdvisorDataFilter()" placeholder="Ex. Rep. Code, name" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="submissionApeByAdvisorTableFilterFc"
                        (keyup)="__applySubmissionApeByAdvisorDataFilter()" placeholder="Search advisors..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="submissionApeByAdvisorTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearSubmissionApeByAdvisorSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Submission APE Data List table -->
                <div id="submission-ape-by-advisor-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="submissionApeByAdvisorTableDataSource" matSort matSortDisableClear
                        matSortActive="yearPendingSinglifeCase" matSortDirection="desc"
                        #submissionApeByAdvisorTableSort="matSort" class="custom-mat-table">

                        <!-- Rep Code Column (rowspan=2) -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 100px;"> {{apeData.repCode}} </td>
                        </ng-container>

                        <!-- Person Name Column (rowspan=2) -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                {{apeData.personName}} </td>
                        </ng-container>

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year nonsinglife group -->
                        <ng-container matColumnDef="header-row2-year-pendinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Pending Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.monthSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Pendinglife APE Column -->
                        <ng-container matColumnDef="yearPendingSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearPendingSinglife |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Pendinglife Case Column -->
                        <ng-container matColumnDef="yearPendingSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearPendingSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- First Header Row (with Rep Code, Name, Group Headers, and Year Total) -->
                        <tr mat-header-row *matHeaderRowDef="submissionApeByAdvisorTableDisplayFirstColumn">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="submissionApeByAdvisorTableDisplaySecondColumn; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: submissionApeByAdvisorTableDisplayDataRow;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Submission APE Data Table Paginator -->
                    <mat-paginator #submissionApeByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of submission APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- APE list By Branches (corporate,BDM)  -->

    <!-- Incepted APE By Branches-->
    <div id="incepted-ape-by-branch-table-container" class="container-fluid"
        [hidden]="isInceptedApeByBranchTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-branch-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-branch-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By branch)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Incepted APE (By branch) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By branch)</mat-label>
                        <input matInput [formControl]="inceptedApeByBranchTableFilterFc"
                            (keyup)="__applyInceptedApeByBranchDataFilter()" placeholder="Ex. Branch" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByBranchTableFilterFc"
                        (keyup)="__applyInceptedApeByBranchDataFilter()" placeholder="Search branch..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByBranchTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearInceptedBranchSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Incepted APE Data List table -->
                <div id="incepted-ape-by-branch-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByBranchTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByBranchTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Branch Name Column — carries the chevron that expands the carrier chips -->
                        <ng-container matColumnDef="branchName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 240px;">
                                <button type="button" class="ape-expand-btn"
                                    [class.open]="isInceptedBranchRowExpanded(apeData.branchName)"
                                    [attr.aria-expanded]="isInceptedBranchRowExpanded(apeData.branchName)"
                                    [attr.aria-label]="'Show carrier breakdown for ' + apeData.branchName"
                                    (click)="toggleInceptedBranchRow(apeData.branchName)">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                                <a class="branch-popup-link"
                                    (click)="__displayInceptedApeBranchWiseAdvisors(apeData.branchName)">{{apeData.branchName}}</a>
                            </td>
                        </ng-container>

                        <!-- MTD — total across every carrier, expanding into per-carrier chips -->
                        <ng-container matColumnDef="mtdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="monthTotal"
                                class="align-middle fw-bold"> Month to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.monthTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.monthTotalCase }} cases</span>
                                </div>
                                @if (isInceptedBranchRowExpanded(apeData.branchName)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.mtdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.mtdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.mtdCase }}
                                                {{ carrier.mtdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- YTD — same cell, year to date -->
                        <ng-container matColumnDef="ytdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="yearTotal"
                                class="align-middle fw-bold"> Year to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell ytd">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.yearTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.yearTotalCase }} cases</span>
                                </div>
                                @if (isInceptedBranchRowExpanded(apeData.branchName)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.ytdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.ytdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.ytdCase }}
                                                {{ carrier.ytdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- Year Total Column — hidden for now; the YTD cell already carries the
                             same figure. Also commented out of the display column list in the .ts.
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold"> Year Total
                            </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end ape-year-total"> {{apeData.yearTotal
                                |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>
                        -->

                        <!-- Header Row -->
                        <tr mat-header-row
                            *matHeaderRowDef="inceptedApeByBranchTableDisplayColumn; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByBranchTableDisplayColumn;"
                            [class.ape-row-open]="isInceptedBranchRowExpanded(row.branchName)"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="3">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByBranchTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>


    <!-- Submission APE By Branches-->
    <div id="submission-ape-by-branch-table-container" class="container-fluid"
        [hidden]="isSubmissionApeByBranchTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="submission-ape-by-branch-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="submission-ape-by-branch-table-exapansion-header">
                        <h5 class="page-header">Submission & Pending APE (By branch)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Submission APE (By branch) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By branch)</mat-label>
                        <input matInput [formControl]="inceptedApeByBranchTableFilterFc"
                            (keyup)="__applySubmissionApeByBranchDataFilter()" placeholder="Ex. Branch" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="submissionApeByBranchTableFilterFc"
                        (keyup)="__applySubmissionApeByBranchDataFilter()" placeholder="Search branch..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="submissionApeByBranchTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearSubmissionBranchSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Submission APE Data List table -->
                <div id="submission-ape-by-branch-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="submissionApeByBranchTableDataSource" matSort matSortDisableClear
                        matSortActive="yearPendingSinglifeCase" matSortDirection="desc"
                        #submissionApeByBranchTableSort="matSort" class="custom-mat-table">

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branchName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;">
                                <a class="branch-popup-link"
                                    (click)="__displaySubmissionApeBranchWiseAdvisors(apeData.branchName)">{{apeData.branchName}}</a>
                            </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 month nonsinglife group -->
                        <!-- <ng-container matColumnDef="header-row2-month-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (MTD)
                            </th>
                        </ng-container> -->

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Submission Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year nonsinglife group -->
                        <ng-container matColumnDef="header-row2-year-Pending-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Pending Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end">{{ apeData.monthSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.monthSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSubmissionSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSubmissionSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSubmissionSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearSubmissionSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Pending APE Column -->
                        <ng-container matColumnDef="yearPendingSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearPendingSinglife |
                                currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}}</td>
                        </ng-container>

                        <!-- Year Pending Case Column -->
                        <ng-container matColumnDef="yearPendingSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center">
                                {{apeData.yearPendingSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- First Header Row (with Branch, Group Headers, and Year Total) -->
                        <tr mat-header-row
                            *matHeaderRowDef="['branchName', 'header-row2-month-singlife-group', 'header-row2-year-singlife-group', 'header-row2-year-Pending-group']; sticky: true">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="['monthSubmissionSinglife', 'monthSubmissionSinglifeCase', 'yearSubmissionSinglife', 'yearSubmissionSinglifeCase', 'yearPendingSinglife', 'yearPendingSinglifeCase']; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: submissionApeByBranchTableDisplayColumn;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #submissionApeByBranchTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of submission APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- Individual Incepted APE By Branch — rep-level rows, MTD only -->
    <div id="individual-incepted-ape-by-branch-table-container" class="container-fluid"
     [hidden]="isindividualInceptedApeByBranchTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="individual-incepted-ape-by-branch-table-exapansion-panel" [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title id="individual-incepted-ape-by-branch-table-exapansion-header">
                        <h5 class="page-header">Individual Incepted APE (By branch)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a"
                        [formControl]="individualInceptedApeByBranchTableFilterFc"
                        (keyup)="__applyIndividualInceptedApeByBranchDataFilter()"
                        placeholder="Search rep code, name or branch..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="individualInceptedApeByBranchTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearIndividualInceptedApeByBranchSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <mat-divider class="pias-divider"></mat-divider>

                <!-- Individual Incepted APE Data List table -->
                <div id="individual-incepted-ape-by-branch-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="individualInceptedApeByBranchTableDataSource" matSort
                        matSortDisableClear matSortActive="monthTotal" matSortDirection="desc"
                        #individualInceptedApeByBranchTableSort="matSort" class="custom-mat-table">

                        <!-- Rep Code Column — carries the chevron that expands the carrier chips -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 130px;">
                                <button type="button" class="ape-expand-btn"
                                    [class.open]="isIndividualInceptedBranchRowExpanded(apeData.repCode)"
                                    [attr.aria-expanded]="isIndividualInceptedBranchRowExpanded(apeData.repCode)"
                                    [attr.aria-label]="'Show carrier breakdown for ' + apeData.repCode"
                                    (click)="toggleIndividualInceptedBranchRow(apeData.repCode)">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                                {{apeData.repCode}}
                            </td>
                        </ng-container>

                        <!-- Person Name Column -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                {{apeData.personName}} </td>
                        </ng-container>

                        <!-- Branch Name Column -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                         <!-- YTD — same cell, year to date -->
                        <ng-container matColumnDef="ytdByCarrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="yearTotal"
                                class="align-middle fw-bold"> Year to Date </th>
                            <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell ytd">
                                <div class="ape-cell-head">
                                    <span class="ape-cell-total">{{ apeData.yearTotal | currency: 'SGD' :
                                        'symbol-narrow' : '1.0-0' }}</span>
                                    <span class="ape-cell-cases">{{ apeData.yearTotalCase }} cases</span>
                                </div>
                                @if (isIndividualInceptedBranchRowExpanded(apeData.repCode)) {
                                <div class="ape-cell-breakdown">
                                    <div class="ape-mix">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                        <span class="ape-mix-seg" [style.width]="carrier.ytdShare"
                                            [style.background]="carrier.color"></span>
                                        }    
                                        }
                                    </div>
                                    <div class="ape-chips">
                                        @for (carrier of carriersOf(apeData); track carrier.name) {
                                        @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){       
                                        <span class="ape-chip">
                                            <span class="ape-chip-dot"
                                                [style.background]="carrier.color">{{ carrier.initial }}</span>
                                            <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                            <span class="ape-chip-ape">{{ carrier.ytdApe | currency: 'SGD' :
                                                'symbol-narrow' : '1.0-0' }}</span>
                                            <span class="ape-chip-cases">{{ carrier.ytdCase }}
                                                {{ carrier.ytdCase === 1 ? 'case' : 'cases' }}</span>
                                        </span>
                                        }
                                        }
                                    </div>
                                </div>
                                }
                            </td>
                        </ng-container>

                        <!-- Header Row -->
                        <tr mat-header-row
                            *matHeaderRowDef="individualInceptedApeByBranchTableDisplayDataRow; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: individualInceptedApeByBranchTableDisplayDataRow;"
                            [class.ape-row-open]="isIndividualInceptedBranchRowExpanded(row.repCode)"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Individual Incepted APE Data Table Paginator -->
                    <mat-paginator #individualInceptedApeByBranchTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons
                        aria-label="Select page of individual incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <br>
</div>